import styled from 'styled-components/macro';
import { colorAccentError100, colorAccentSuccess200 } from '@yme/tokens/colors';
export const IconWrapper = styled.div `
  padding: 12px;
  background-color: ${({ hasError }) => (hasError ? colorAccentError100 : colorAccentSuccess200)};
  border-radius: 50%;
`;
